import * as React from 'react';

import * as styles from './Specifications.css';

export const Specifications = (props: React.PropsWithChildren): React.JSX.Element => {
  return <div className={styles['container']}>{props.children}</div>;
};
